<template>
    <div class="container feedback template-bg-gray">
        <div class="row" >
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec ">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div class="card form-wrapper" v-bind:class="{'thankupageplr88': !isBeforRequest}">
                        <div class="feedback_container">
                            <div class="community-logo">
                                <img v-if="this.hasLogo" :src="community.customSettings.logoURL" class="top-logo custom-logo" :alt="community.content.parameter2 ? community.content.parameter2 : 'Community Logo'">
                            </div>
                            <template  v-if="this.isBeforRequest" >
                                <h1 class="template-title  my-text-center common-space-from-logo mb35">Send a message</h1>
                                <form @submit.prevent="save('email-form')" autocomplete="off" data-vv-scope="email-form"  class="template-form">
                                    <div class="row">
                                        <div class="col-md-6 mb-17">
                                            <div class="input-group">
                                                <label class="template-label">Your Email Address</label><span class="required-symbol"> *</span>
                                                <input type="text" v-focus class="form-control input-value pt-input input-focus" id="from_email" aria-label="Your Email Address" v-model="advice.from_email" name="from_email" placeholder="What's your email address?" v-validate.continues="'required|email'" v-bind:class="{'request-form-error-border': errors.has('email-form.from_email') }" @input="e => advice.from_email = sanitizeInput(e.target.value)">
                                                <p v-show="errors.has('email-form.from_email')" class="error" >{{ errors.first('email-form.from_email') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 mb-17 mr-1">
                                            <div class="input-group">
                                                <label class="template-label">Email</label><span class="required-symbol"> *</span>
                                                <input type="text" class="form-control input-value pt-input input-focus" id="email" aria-label="Email" v-model="advice.email" name="email" placeholder="" v-validate.continues="'required|email'" v-bind:class="{'request-form-error-border': errors.has('email-form.email') }" @input="e => advice.email = sanitizeInput(e.target.value)">
                                                <p v-show="errors.has('email-form.email')" class="error" >{{ errors.first('email-form.email') }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="template-label">Email Subject <span class="required-symbol"> *</span> </label>
                                                <input type="text" class="form-control input-value pt-input w-100 input-focus" id="subject" placeholder="Please enter a subject line for your request" aria-label="Email Subject" v-model="advice.subject" name="subject" v-validate="'required'" v-bind:class="{'request-form-error-border': errors.has('email-form.subject') }" @input="e => advice.subject = sanitizeInput(e.target.value)">
                                                <p class="error" v-show="errors.has('email-form.subject')" >{{errors.first('email-form.subject')}}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mt-6">
                                            <div class="input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2">
                                                <textarea class="form-control request-form-question-textarea" name="message" v-validate.continues="'required|max:2000'" v-on:keyup="countdown" rows="5" :maxlength="max" placeholder="Your message here" v-model="advice.message" v-bind:class="{'request-form-error-border': errors.has('message') }" @input="e => advice.message = sanitizeInput(e.target.value)"></textarea>
                                                <div class="form-group  pd-remove unsubscribe-btn mb-0-custom">
                                                    <div class="char-counter template-subject-counter"
                                                        v-bind:class="{'char-count-error': exceedsMaxCount }"
                                                    >{{remainingCount}}  / 2000</div>
                                                </div>
                                            </div>
                                            <p class="error" v-show="errors.has('email-form.message')" >{{errors.first('email-form.message')}}</p>
                                        </div>
                                    </div>
                                    <div class="btn-block text-right mlr0">
                                        <md-button type="submit" name="helpAction" v-bind:style="reviewBtn"
                                        class="btn btn_info template-review-submit template-button template-button-width mlr0">Send</md-button>
                                    </div>
                                    <div id="tips" class="my">
                                        <p class="box-sub-heading custom-content my-text-center">Not sure how to ask? Read our
                                        <a tabindex="0" :href="community.content.tips" class="text-underline" target="_blank" v-if="community.content && community.content.tips && community.content.tips.length">tips</a>
                                        <span v-else>tips</span>.
                                        </p>
                                    </div>
                                </form>
                            </template>
                            <template v-else>
                                <div class='header-text text-center unsubscribepage-thankumsg'>
                                    <h1 class="template-title common-space-from-logo">Thank you!</h1>
                                    <!-- <div v-if="community.content && community.content.requestPageThankYou" class="box-sub-heading text-left content-textleft" v-html="community.content.requestPageThankYou"></div> -->
                                    <!-- <div  v-else class="box-sub-heading text-left content-textleft">We will now recruit the right experts to help you.</div> -->
                                </div>
                            </template>
                        </div>
                    </div>
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use</a>
                        </li>
                        <li>
                            <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                            <a href="javascript:void(0)" v-else>Opt Out</a>
                        </li>
                    </ul>
                    <div class="unsubscribe-community-logo">
                        <a href="https://www.protopia.co" target="_blank"><img :src="logoURL" alt='Community Logo'></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import { sanitizeInput } from '../utils/sanitizer';
export default {
    props: ["askid", "adviserid"],
    data() {
        return {
            api: new API(),
            advice: {},
            community: {},
            fullPage: true,
            hasLogo: false,
            max: 2000,
            remainingCount: 0,
            message: "",
            subject: "",
            isBeforRequest: true,
            exceedsMaxCount: false,
            reviewBtn: {
                background: '#9178A0',
                color: '#ffffff'
            },
            logoURL: process.env.LOGO_URL
        };
    },
    watch: {
        $route: "loadData"
    },
    created() {
        this.loadData();
        const dict = {
            custom: {
                email: {
                    required: () => "Please enter your email address",
                    email: () => "Please enter a valid email address"
                },
                from_email: {
                    required: () => "Please enter your email address",
                    email: () => "Please enter a valid email address"
                },
                subject: {
                    required: () => "Please enter a subject"
                },
                message: {
                    required: () => "Please enter a message",
                    max: () => "Message may not exceed 2000 characters"
                }
            }
        };
        this.$validator.localize("en", dict);
    },
    methods: {
        sanitizeInput(input) {
            return sanitizeInput(input);
        },
        countdown: function() {
            if (this.advice.message) {
                this.remainingCount = this.max - this.advice.message.length;
                this.remainingCount === 0 ? (this.exceedsMaxCount = true) : (this.exceedsMaxCount = false);
            }
        },
        loadData: async function() {
            await this.api.get(`asks/${this.$route.query.askid}`).then(ask => {
                if (ask.data) {
                    this.advice.askid = ask.data._id;
                    this.community = ask.data.community;
                    if (this.community.content.parameter3) {
                        this.subject = this.community.content.parameter3
                    }
                    // this.advice.subject = 'Re: ' + ask.data.subject;
                    this.advice.subject = `Message from ${this.subject} member`;
                    this.reviewBtn = {
                        background: this.community.customSettings.primaryBtnBgColor,
                        color: this.community.customSettings.primaryTxtColor
                    };
                    if (this.community.customSettings && this.community.customSettings.logoURL !== "") {
                        this.hasLogo = true;
                    }
                    this.advice.email = ask.data.createdByMemberID.emails[0];
                } else {
                    this.$router.push('/');
                }
            })
            this.$validator.errors.clear();
            this.$validator.reset();
        },
        save: async function(scope) {
            this.$validator.validateAll(scope).then(async result => {
                if (result) {
                    var communicationObj = {
                        sender_email: this.advice.from_email,
                        to_email: this.advice.email,
                        message: this.advice.message,
                        askid: this.advice.askid,
                        subject: this.advice.subject
                    }
                    document.title = 'Thank You';
                    this.isBeforRequest = false;
                    window.scrollTo(0, 0);
                    await this.api.post(`communication/send-email`, communicationObj).then(response => {
                        if (response.data) {
                            // document.title = 'Thank You';
                            // this.isBeforRequest = false;
                        } else {
                            this.$toast.error(`Something went wrong`);
                        }
                    });
                }
            });
        },
        redirectUrls: function(path) {
            window.open(path, '_blank');
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Communication.vue